import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPutRequest,
  formDataPostRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridData,id) {
    const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Projects/all/${id}?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `Projects/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllProjectList() {
  return getRequest(
    `Projects/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return deleteRequest(
    `Projects/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return formDataPostRequest(
    `Projects/create`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data) {
    return formDataPutRequest(
    `Projects`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllProjectListWithIsActive() {
  return getRequest(
    `Projects/all/project/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const projectService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  getAllProjectList,
  getAllProjectListWithIsActive
};
